import * as yup from 'yup';

const initialValues = {
  weightage: '',
};

const validationSchema = yup.object().shape({
  weightage: yup
    .number()
    .typeError('Weightage must be a number')
    .min(1, 'Weightage must be at least 1')
    .max(100, 'Weightage cannot exceed 100')
    .required('Weightage is required'),
});

export { initialValues, validationSchema };
